<template>
  <div>
    <nav>
      <div class="c-dealer-left">
        <a href="http://www.audirybnik.pl/">
          <p>Audi</p>
          <p class="">Porsche Rybnik</p>
        </a>
      </div>
      <a href="http://www.audirybnik.pl/"><img src='@/assets/images/elem/logo.png' /></a>
    </nav>
    <div class="c-model-baner">
      <img class='baner' src='@/assets/images/korzysci-sosnowiec-nowybaner-pazdziernik.jpg' />
      <div class="c-baner-text">
        <h3 class="c-baner-text2">  Modele Audi z rocznika 2020 z korzyścią do 24%!</h3>
      </div>
      <div class="pulse-div" v-on:click="scrolltoelement()">
        <span class="pulse"><img src='@/assets/images/elem/mouse.png' alt='Ruszaj po swoje' /></span>
        <p class="check">Sprawdź</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'headercomponent',
  methods: {
    scrolltoelement: function scrolltoelement() {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: document.getElementsByClassName('.c-model-baner-text').offsetTop
      });
    },
  }

};
</script>
